import { safeScrollTo } from "@faire/retailer-visitor-shared/lib/safeScrollTo";
import { SHOP_SECTION_ID, TOP_OF_PRODUCT_SPACE } from "@faire/retailer-visitor-shared/views/brand/consts";
import { getDocumentOrThrow } from "@faire/web--source/common/globals/getDocument";
import { throttleIfPossible } from "@faire/web--source/common/globals/throttleIfPossible";
import { useRef } from "react";
var scrollToShopSectionThrottleMS = 500;
function scrollToShopSection() {
    var _getDocumentOrThrow_getElementById;
    var _getDocumentOrThrow_getElementById_offsetTop;
    var offsetTop = ((_getDocumentOrThrow_getElementById_offsetTop = (_getDocumentOrThrow_getElementById = getDocumentOrThrow().getElementById(SHOP_SECTION_ID)) === null || _getDocumentOrThrow_getElementById === void 0 ? void 0 : _getDocumentOrThrow_getElementById.offsetTop) !== null && _getDocumentOrThrow_getElementById_offsetTop !== void 0 ? _getDocumentOrThrow_getElementById_offsetTop : 0) - TOP_OF_PRODUCT_SPACE;
    safeScrollTo({
        left: 0,
        top: offsetTop,
        behavior: "smooth"
    });
}
export var useThrottledScrollToShopSection = function() {
    var throttledFn = useRef(throttleIfPossible(scrollToShopSection, scrollToShopSectionThrottleMS));
    return throttledFn.current;
};
